import React, { useState } from 'react'
import { Modal, Button, Form } from 'semantic-ui-react'
import ProductsDropDown from '../shared/ProductsDropDown'
import PropTypes from "prop-types"
import { useTextResources } from '../../language'
import formatCurrency from 'format-currency'
import { Currencies } from '../shared/currencies'

const SelectProductPopup = ({open,onCancel, onSelect, spec, ...rest})=>{
    const text = useTextResources()
    const [productID, setProductID] = useState(null)

    const currencyFormat = currencyID => {
        return {
            format: '%v%s', 
            symbol: Currencies[currencyID]?.symbol,
            locale: document.documentElement.lang || "he-IL"
        }
    }
    
    const productLabel = React.useCallback(item => {
        return formatCurrency(item.TotalAmountAfterTax, currencyFormat(item.CurrencyId))
    }, [])
    
    return <Modal size="tiny" open={open} style={{zIndex: 1000000}} {...rest} >
        <Modal.Header>{text("SelectProduct")}</Modal.Header>
        <Modal.Content>
            <Form>
                <Form.Field label={text("Product")} required control={ProductsDropDown}  descriptionField="RateName" labelField={productLabel} spec={spec} onChange={setProductID}
                />
            </Form>
        </Modal.Content>
        <Modal.Actions>
            <Button negative size="small" onClick={onCancel}>{text("Cancel")}</Button>
            <Button positive size="small" onClick={()=>onSelect(productID)}>{text("OK")}</Button>
        </Modal.Actions>
    </Modal>
}

SelectProductPopup.propTypes = {
    open: PropTypes.bool,
    onCancel: PropTypes.func,
    onSelect: PropTypes.func,
    spec: PropTypes.any
}

export default SelectProductPopup